import { Navigate, Outlet, useSearchParams } from "react-router-dom";

import { useGetCurrentUser } from "~/api/users/users";
import {
  AuthImageProvider,
  useAuthImage,
} from "~/features/auth/context/AuthImageContext";
import { useThemedOnboardingImage } from "~/hooks/useThemedOnboardingImage";
import ErrorBoundaryWrapper from "../ErrorBoundaryWrapper";
import { SplitLayout } from "./SplitLayout";

const AuthLayoutContent = () => {
  const { imageSrc } = useAuthImage();

  return (
    <SplitLayout imageSrc={imageSrc}>
      <Outlet />
    </SplitLayout>
  );
};

export const AuthLayout = () => {
  const { data: userInfo } = useGetCurrentUser();
  const [searchParams] = useSearchParams();
  const defaultImage = useThemedOnboardingImage("create-account");

  if (userInfo && searchParams.get("guest") !== "true") {
    const retpath = searchParams.get("retpath");
    const to = retpath ? decodeURIComponent(retpath) : "/";
    return <Navigate to={to} replace />;
  }

  return (
    <ErrorBoundaryWrapper>
      <AuthImageProvider defaultImage={defaultImage}>
        <AuthLayoutContent />
      </AuthImageProvider>
    </ErrorBoundaryWrapper>
  );
};
